<div *ngIf="isSubmitted" class="demographic-view">
  <h1 class="mat-h1 color-primary text-small-caps no-bottom-margin">{{ 'SUMMARY_SECTION.TITLE' | translate }}</h1>
  <hr>
  <div *ngIf="isInitialized">
    <div class="summary-details">
      <div class="right-border border-bottom sales-comparison-widget-container container default-padding mat-elevation-z1 clickable"
           fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" matRipple >
        <div fxLayout="column" >
          <small class="color-muted">{{ 'SUMMARY_SECTION.PROJECTED_WEEKLY_SALES' | translate }}</small>
          <strong *ngIf="weeklySalesLowerRange && weeklySalesUpperRange">{{roundToThousand(weeklySalesLowerRange ) | number:'1.0-0' }} - {{roundToThousand(weeklySalesUpperRange) | number:'1.0-0'}}</strong>
          <strong *ngIf="!(weeklySalesLowerRange && weeklySalesUpperRange)">--</strong>
        </div>
      </div>

      <div class="right-border border-bottom sales-comparison-widget-container container default-padding mat-elevation-z1 clickable"
           fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" matRipple>
        <div fxLayout="column">
          <small class="color-muted">{{ 'SUMMARY_SECTION.TOTAL_SALES_PROJECTION' | translate }}</small>
          <strong [ngClass]="getProjectionStatusClass(totalSalesProjectionStatus)">{{ totalSalesProjectionStatus }}</strong>
          <small *ngIf="!bannerCBSAAverages?.cbsa && totalSalesProjectionStatus !== '--'" class="color-muted">
            {{ 'SUMMARY_SECTION.RELATIVE_OVERALL_AVG' | translate }}
          </small>
          <small *ngIf="bannerCBSAAverages?.cbsa" class="color-muted">
            {{ 'SUMMARY_SECTION.OUT_OF' | translate:{name: bannerCBSAAverages?.name, state: getStateAbbreviation(cbsaName)} }}
          </small>
        </div>
      </div>

      <div class="left-border border-bottom sales-comparison-widget-container container default-padding mat-elevation-z1 clickable"
           fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" matRipple>
        <div fxLayout="column">
          <small class="color-muted">{{ 'SUMMARY_SECTION.SALES_PER_SQFT' | translate }}</small>
          <strong [ngClass]="getProjectionStatusClass(sqftProjectionStatus)">{{ sqftProjectionStatus }}</strong>
          <small *ngIf="!bannerCBSAAverages?.cbsa && sqftProjectionStatus !== '--'" class="color-muted">
            {{ 'SUMMARY_SECTION.RELATIVE_OVERALL_AVG' | translate }}
          </small>
          <small *ngIf="bannerCBSAAverages?.cbsa" class="color-muted">
            {{ 'SUMMARY_SECTION.OUT_OF' | translate:{name: bannerCBSAAverages?.name, state: getStateAbbreviation(cbsaName)} }}
          </small>
        </div>
      </div>
    </div>

    <div class="summary-details">
      <div class="right-border border-top sales-comparison-widget-container container default-padding mat-elevation-z1 clickable"
           fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" matRipple>
        <div fxLayout="column">
          <small class="color-muted">{{ 'SUMMARY_SECTION.CLOSEST_STORE' | translate:{banner: nearestStore?.bannerName} }}</small>
          <strong *ngIf="nearestStore">
            {{ nearestStore?.distance | number:'1.2-2' }} mi
          </strong>
          <strong class="color-red" *ngIf="((densityClass === 'Urban' && nearestStore?.distance < 2) || (densityClass === 'Suburban' && nearestStore?.distance < 3) || (densityClass === 'Rural' && nearestStore?.distance < 5)) && nearestStore">
            {{ 'SUMMARY_SECTION.CANNIBALIZATION_RISK' | translate }}
          </strong>
          <strong *ngIf="!nearestStore">--</strong>
        </div>
      </div>

      <div class="right-border border-top sales-comparison-widget-container container default-padding mat-elevation-z1 clickable"
           fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" matRipple>
        <div fxLayout="column">
          <small class="color-muted">{{ 'SUMMARY_SECTION.CLOSEST_COMPETITOR' | translate }}</small>
          <strong>{{ closetCompetitor?.storeName }} - {{ closetCompetitor?.distance | number:'1.2-2' }} mi</strong>
        </div>
      </div>
      <div  class="left-border border-top sales-comparison-widget-container container default-padding mat-elevation-z1 clickable"
           fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" matRipple >
        <div fxLayout="column" >
          <small class="color-muted">{{ 'SUMMARY_SECTION.FUTURE_OPENINGS' | translate }}</small>
          <small>{{ 'SUMMARY_SECTION.FUTURE_OPENINGS_COUNT' | translate }}</small>
          <strong>{{futureStoreCount}}    /  {{nearestFutureStoreDistance | number:'1.2-2'}} mi ({{nearestFutureStoreName}})</strong>
        </div>
      </div>
    </div>
  </div>

  <div class="loader-container" *ngIf="!isInitialized" fxLayoutAlign="center center">
    <img src="assets/images/cube-preloader.svg" height="90px" width="90px;" alt="{{ 'COMMON.LOADING' | translate }}"/>
  </div>
</div>
